module.exports = __webpack_public_path__ + "img/map.7787e054.jpg";